const ticker = $("#sg-countdown-banner");
if (ticker.length) {
  $("body").addClass("has-announcement-bar");
  
  const countdown = (endTime) => {
    const now = new Date();
    const timeLeft = endTime - now;
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    return {
      days: days < 10 ? `0${days}` : days,
      hours: hours < 10 ? `0${hours}` : hours,
      minutes: minutes < 10 ? `0${minutes}` : minutes,
      seconds: seconds < 10 ? `0${seconds}` : seconds,
    };
  };

  const updateCountdown = (section) => {
    let date = moment.tz(section.data("finish-time").replace(/-/g, "/"), "Europe/Madrid").subtract(1,'hours');
    //let date = new Date(section.data("finish-time").replace(/-/g, "/"));
    if (date > new Date()) {
      const { days, hours, minutes, seconds } = countdown(
        moment.tz(section.data("finish-time").replace(/-/g, "/"), "Europe/Madrid").subtract(1,'hours')
        //new Date(section.data("finish-time").replace(/-/g, "/"))
      );
      section.css("display", "grid");
      section.find(".days .number").text(days);
      section.find(".hours .number").text(hours);
      section.find(".minutes .number").text(minutes);
      section.find(".seconds .number").text(seconds);
    } else {
      section.css("display", "none");
    }
  };

  updateCountdown($("#sg-countdown-banner"));
  let interval = setInterval(() => updateCountdown($("#sg-countdown-banner")), 1000);
  
  $(window).on("shopify:section:load", function ({ target }) {
    clearInterval(interval);
    updateCountdown($("#sg-countdown-banner"));
    interval = setInterval(() => updateCountdown($("#sg-countdown-banner")), 1000);
  });
}
